import { observer } from 'mobx-react-lite';
import { SyntheticEvent, useEffect, useState } from 'react';
import {
  Button,
  Dropdown,
  Form,
  Header,
  Menu,
  Segment,
  Tab,
} from 'semantic-ui-react';
import { store, useStore } from '../../../../app/stores/store';
import DashboardTemplateCard from './DashboardTemplateCard';
import CreateOrderForm from './CreateOrderForm';
import { Activity } from './../../../../app/models/activity';
import { OrderInitialState, Orders } from '../../../../app/models/orders';
import { v4 as uuid } from 'uuid';
import { DeliveryRequest } from '../../../../app/models/deliveryRequest';
import LoadingComponent from './../../../../app/layout/LoadingComponent';
import {
  WorkflowElement,
  Communication,
  WorkflowOptions,
  Template,
  tempApi,
  WorkFlowSubTasks,
} from '../../../../app/models/template';
import CreateOrderSaveFunction from './CreateOrderSaveFunction';
import agent from '../../../../app/api/agent';
import { userLanguage } from '../../../../app/common/userLanguageSchema/userLanguage';

interface props {
  name?: string;
}

function CreateOrderContainer({ name }: props) {
  const {
    dashboardStore,
    activityStore,
    TemplateStore,
    userStore,
    commonStore,
  } = useStore();

  const {
    loadTemplateIdForCR,
    selectedTemplate,
    loadingTemplate,
    loadingInitialTemp,
  } = TemplateStore;
  const [typeSearch, setTypeSearch] = useState<string>('');
  const [itemLevel, setItemLevel] = useState<Activity | undefined>();
  const [orderState, setOrderState] = useState<Orders>(OrderInitialState);
  const [deliveryData, setDeliveryData] = useState<
    DeliveryRequest | undefined
  >();
  const [templateSelected, SetTemplateSelected] = useState<
    Template | undefined
  >(selectedTemplate);
  const [clonedTemplate, setClonedTemplate] = useState(false);
  const [customerSelected, setCustomerSelected] = useState('');
  const [departmentSelected, setDepartmentSelected] = useState('');
  const [departmentClear, setDepartmentClear] = useState('');
  const [taskSubtaskFound, setTaskSubtaskFound] = useState(false);
  const { user } = userStore;

  useEffect(() => {
    let taskLength = 0;
    let subtaskLength = 0;
    if (templateSelected) {
      taskLength =
        templateSelected?.tasks &&
        templateSelected?.tasks.filter((x) => x.isActive === true).length;
      templateSelected?.tasks
        ?.filter((y) => y.isActive === true)
        .forEach((x) => {
          if (x?.subTasks && x?.subTasks?.length > 0) {
            subtaskLength = x.subTasks.filter(
              (z) => z.isActive === true,
            ).length;
          }
        });
    }

    if (taskLength > 0 && subtaskLength > 0) {
      setTaskSubtaskFound(true);
    } else {
      setTaskSubtaskFound(false);
    }
  }, [templateSelected, dashboardStore.dashboard.CreateOrderTemplate]);

  useEffect(() => {
    let activity = activityStore.selectedActivity;
    setTypeSearch('');
    if (activity) {
      setItemLevel(activity);
      if (activity?.elementtypeid !== undefined) {
        TemplateStore.loadElementTypeById(activity?.elementtypeid);
      }
      if (activity?.itemDeliveryRequest) {
        setDeliveryData(
          activity?.itemDeliveryRequest?.filter(
            (i) => i.isActive === true,
          )?.[0],
        );
      } else {
        setDeliveryData(undefined);
      }
    }
    // eslint-disable-next-line
  }, [activityStore.selectedActivity]);

  const filteredTemplate =
    TemplateStore?.selectedElementTypes?.templateTypes.filter((x) =>
      dashboardStore.dashboard.selectedUserRoleId.includes(x.templateId),
    );
  const templateoptions = filteredTemplate?.map((x) => ({
    key: x.templateId,
    text: x.templateName,
    value: x.templateName + '/' + x.templateId,
  }));
  ///////////////////////handle Select
  const handleSelect = (e: SyntheticEvent, data: any) => {
    if (data.value === '') {
      setTypeSearch('');
      setOrderState(OrderInitialState);
      SetTemplateSelected(undefined);
    } else {
      setTypeSearch(data.value.split('/')[0]);
      loadTemplateIdForCR(data.value.split('/')[1]);
      store.TemplateStore.loadingTemplate = true;
      const oldArr = {
        ...orderState,
        templateId: data.value,
      };
      setOrderState(oldArr);
    }
  };
  ///////////For Client and Department
  useEffect(() => {
    const oldArr: any = {
      ...orderState,
      customerId:
        dashboardStore.dashboard.createOrderClientId || user?.customerName,
      departmentId: dashboardStore.dashboard.createOrderDepartmentId,
    };
    setOrderState(oldArr);
    // eslint-disable-next-line
  }, [
    dashboardStore.dashboard.createOrderClientId,
    dashboardStore.dashboard.createOrderDepartmentId,
  ]);
  //Template Dropdown ----------------------------------------------->>>>>>>>>>>>>>>>>>>>>>>>>>
  const panes = [
    {
      menuItem: (
        userLanguage[0].Level3InventoryRecievingCreateOrder?.IRCOTPL01 as any
      )?.[`${commonStore.language.key}`], //Template
      render: () => (
        <Tab.Pane style={{ height: '32vh' }}>
          <Menu>
            <Dropdown
              placeholder={
                (
                  userLanguage[0].Level3InventoryRecievingCreateOrder
                    ?.IRCODD02 as any
                )?.[`${commonStore.language.key}`]
              } //"Type"
              fluid
              selection
              options={templateoptions}
              clearable
              search
              onChange={handleSelect}
              value={typeSearch}
              searchQuery={typeSearch}
            />
          </Menu>
        </Tab.Pane>
      ),
    },
    {
      menuItem: (
        userLanguage[0].Level3InventoryRecievingCreateOrder?.IRCOTPL02 as any
      )?.[`${commonStore.language.key}`], //"Customization"
      render: () => (
        <Tab.Pane style={{ height: '32vh' }}>
          <DashboardTemplateCard templateSelected={templateSelected} />
        </Tab.Pane>
      ),
    },
  ];
  //////////////  Selected Template UseEffect
  useEffect(() => {
    if (selectedTemplate) {
      // SetTemplateSelected((prevState:any) => {
      const NewIdGenerate = uuid();
      // const Datas = selectedTemplate;
      const temp = {
        ...selectedTemplate,
        tasks: [...selectedTemplate.tasks],
      };
      // change title "isActive" to "false"
      temp.templateId = NewIdGenerate;
      temp.tasks.forEach((task: any) => {
        task.taskId = uuid();
        task.isCurrentTask = false;
        //  if(task.taskIndex===0){
        //   task.isCurrentTask=true
        //  }
        task?.subTasks?.forEach((subtasks: WorkFlowSubTasks) => {
          subtasks.subTaskId = uuid();
          subtasks.isCurrentSubtask = false;
          // if(task.taskIndex=== 0 && subtasks.subtaskIndex===0 ){
          //   subtasks.isCurrentSubtask=true
          // }

          subtasks.communication.forEach((communication: Communication) => {
            communication.id = uuid();
          });
          subtasks.api.forEach((tempApi: tempApi) => {
            tempApi.id = uuid();
          });

          subtasks.elements.forEach((element: WorkflowElement) => {
            element.elementId = uuid();
            element.options.forEach((options: WorkflowOptions) => {
              options.optionId = uuid();
            });
          });
        });
      });
      dashboardStore.updateCreateOrderTemplate(temp);
      setClonedTemplate(true);
      SetTemplateSelected(temp);
    }
    // eslint-disable-next-line
  }, [selectedTemplate]);

  /////////////////////////handle Submit Data
  const handleSubmit = () => {
    CreateOrderSaveFunction(itemLevel, orderState, deliveryData);
    templateSelected?.tasks?.forEach((d) => {
      if (d.isActive) dashboardStore.dashboard.taskTotal += 1;
    });
    dashboardStore.dashboard.prodCount += 1;
    dashboardStore.dashboard.prodPlanTableLength += 1;
    new Promise(() => {
      agent.updateCountOrder.updateCount(store?.userStore?.user?.id || '');
    });
  };
  const handleSelecst = (e: any, data: any) => {
    if (data.name === 'customerId') {
      if (data.value !== '' && e.currentTarget.textContent !== null) {
        dashboardStore.dashboard.createOrderClientId = data.value;
        setCustomerSelected(e.target.textContent);
      } else {
        setCustomerSelected('');
      }
    }
    if (data.name === 'departmentId') {
      if (data.value !== '' && e.currentTarget.textContent !== null) {
        dashboardStore.dashboard.createOrderDepartmentId = data.value;
        setDepartmentSelected(e.target.textContent);
        activityStore.createOrderDepartmentName = e.currentTarget.textContent;
        setDepartmentClear(data.value);
      } else {
        setDepartmentSelected('');
        setDepartmentClear('');
      }
    }
  };

  if (
    (loadingTemplate && selectedTemplate === undefined && !clonedTemplate) ||
    loadingInitialTemp
  ) {
    return <LoadingComponent />;
  }

  const handleCancel = () => {
    setDepartmentSelected('');
    setDepartmentClear('');
    SetTemplateSelected(undefined);
    setTypeSearch('');
  };

  return (
    <Segment
      className={
        dashboardStore.dashboard.onFirstLoadNoTransition
          ? ''
          : dashboardStore.dashboard.setfadeIn
            ? 'fadeIn'
            : 'fadeOut'
      }
      clearing
      style={{ marginTop: '10px', height: '61.7vh' }}
    >
      <Header
        icon="edit"
        size="huge"
        dividing
        as="h1"
        content={
          name === 'Assign Activities'
            ? (userLanguage[0].Level3InventoryRecievingRegister.IRRL04 as any)?.[
              `${commonStore.language.key}`
            ]
            : name === 'Outward Process Instructions'
              ? 'Outward Process Instructions'
              : 'Create Order'
        }
        sub
        color="grey"
      />
      {(dashboardStore.dashboard.valueForL3Inventory === 'Create Order' &&
        dashboardStore.dashboard.AssetTableCreateOrderClicked.length !== 0) ||
      (dashboardStore.dashboard.valueForL3Inventory ===
        'Create Order Receiving' &&
        dashboardStore.dashboard.assetTableCRClicked.length !== 0) ? (
        <div className="create-order-height">
          <CreateOrderForm
            handleSelect={handleSelecst}
            customerSelected={customerSelected}
            departmentSelected={departmentSelected}
            departmentClear={departmentClear}
          />
          <Form>
            <Tab panes={panes} />
          </Form>
          <Button.Group style={{ marginTop: '5px' }} size="small">
            {/* Cancel */}
            <Button onClick={handleCancel}>
              {
                (
                  userLanguage[0].Level3InventoryRecievingCreateOrder
                    ?.IRCOB02 as any
                )?.[`${commonStore.language.key}`]
              }
            </Button>
            <Button.Or
              text={
                (
                  userLanguage[0].Level3InventoryRecievingCreateOrder
                    ?.IRCOB03 as any
                )?.[`${commonStore.language.key}`]
              }
            />
            {/* Save */}
            <Button
              positive
              onClick={handleSubmit}
              disabled={
                departmentSelected === '' ||
                typeSearch === '' ||
                !taskSubtaskFound
              }
            >
              {
                (
                  userLanguage[0].Level3InventoryRecievingCreateOrder
                    ?.IRCOB04 as any
                )?.[`${commonStore.language.key}`]
              }
            </Button>
          </Button.Group>
        </div>
      ) : (
        <p style={{ marginTop: '10px' }}>
          {
            (
              userLanguage[0].Level3InventoryRecievingCreateOrderTab
                ?.IRCOTL01 as any
            )?.[`${commonStore.language.key}`]
          }
        </p>
      )}
    </Segment>
  );
}

export default observer(CreateOrderContainer);
